import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    reorderUrl: String,
    conversionErrorAction: String,
  }

  static targets = ["ListItem", "ListItemTemplate", "TemplateFiletypeSvg", "TemplateUploadedTime", "EditNameButton", "NameInput", "NameText", "ControlsButton", "ControlsDropdown", "ConvertingStatus", "VideoStatusContainer", "VideoStatusText", "ViewFileLink", "DeleteFileLink"]

  connect() {
    this.startingEmpty = this.ListItemTargets.length == 0
    this.conversionIntervals = {}
    this.videoIntervals = {}

    new Sortable(this.element, {
      group: 'file_list_group',
      ghostClass: '!bg-blue-200',
      animation: 150,
      onEnd: this.onSortEnd.bind(this)
    })

    $(document).click(() => {
      this.ControlsDropdownTargets.map((target) => target.classList.add("hidden"))
    })

    this.initializeExistingVideoPolling()
  }

  callControllerMethod(controllerAndMethod, payload = null, formElement = null, id = null) {
    const parts = controllerAndMethod.split('->')
    const controller = parts[0]
    const method = parts[1]
    let controllerElement
    if (id) {
      const controllerElems = document.querySelectorAll(`[data-controller="${controller}"]`)
      controllerElement = Array.from(controllerElems).find((elem) => elem.id == id)
    } else {
      controllerElement = document.querySelectorAll(`[data-controller="${controller}"]`)[0]
    }
    const controllerInstance = this.application.getControllerForElementAndIdentifier(controllerElement, controller)
    if (controllerInstance) {
      if (payload && formElement) {
        controllerInstance[method](payload, formElement)
      } else if (payload) {
        controllerInstance[method](payload)
      } else if (formElement) {
        controllerInstance[method](formElement)
      } else {
        controllerInstance[method]()
      }
    }
  }

  async onSortEnd(e) {
    const attachmentId = e.item.dataset.id || e.item.dataset.attachmentId
    let newPosition = e.newIndex

    if (this.startingEmpty) {
      newPosition -= 1
    }

    const request = new FetchRequest("PUT", `${this.reorderUrlValue}?attachment_id=${attachmentId}&new_position=${newPosition}`, { responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      // do nothing
    } else {
      const responseJson = await response.json

      alert("There was an error moving this item: ", responseJson.error)
    }
  }

  onEditNameClick(e) {
    e.preventDefault()
    const button = e.currentTarget
    const attachmentId = button.dataset.attachmentId
    const nameInput = this.NameInputTargets.find((target) => target.dataset.attachmentId == attachmentId)
    const nameText = this.NameTextTargets.find((target) => target.dataset.attachmentId == attachmentId)

    button.classList.add("hidden")
    nameText.classList.add("hidden")
    nameInput.classList.remove("hidden")
    nameInput.focus()
    const val = nameInput.value; //store the value of the element
    nameInput.value = ''; //clear the value of the element
    nameInput.value = val;
  }

  async onDeleteClick(e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.confirm("Are you sure you want to delete this file?")) {
      const request = new FetchRequest("DELETE", e.target.getAttribute("href"), { responseKind: 'json' })
      const response = await request.perform()

      if (response.ok) {
        const fileListItem = e.target.closest('li')
        fileListItem.remove()
      } else {
        console.warn('Error deleting file: ', response.body)
        alert("There was an error deleting the file.")
      }
    }
  }

  onNameInputChange(e) {
    e.preventDefault()

    if (e.type == 'keyup' && e.keyCode == 13) {
      e.stopImmediatePropagation()
      e.target.blur()
    }

    if (e.type == 'blur') {
      this.submitUserFilenameInput(e.target)
    }
  }

  hideUserFilenameInput(input, value) {
    const button = this.EditNameButtonTargets.find((target) => target.dataset.attachmentId == input.dataset.attachmentId)
    const nameText = this.NameTextTargets.find((target) => target.dataset.attachmentId == input.dataset.attachmentId)

    button.classList.remove("hidden")
    nameText.innerHTML = value
    nameText.classList.remove("hidden")
    input.classList.add("hidden")
  }

  async submitUserFilenameInput(input) {
    const request = new FetchRequest("PUT", input.dataset.url, { body: JSON.stringify({ attachment: { user_filename: input.value } }), responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      const responseJson = await response.json

      this.hideUserFilenameInput(input, responseJson.filename)
    } else {
      const responseJson = await response.json

      alert(responseJson.errors)
    }
  }

  onControlsClick(e) {
    e.preventDefault()
    e.stopPropagation()

    const controls = e.currentTarget
    const attachmentId = controls.dataset.attachmentId
    const dropdown = this.ControlsDropdownTargets.find((target) => target.dataset.attachmentId == attachmentId)
    dropdown.classList.remove("hidden")
  }

  onAppendListItem(attachment) {
    const newListItem = this.ListItemTemplateTarget.cloneNode(true)
    newListItem.setAttribute('data-attachment-id', attachment.id)
    newListItem.dataset.attachmentId = attachment.id
    newListItem.dataset.videoStatus = attachment.video_status || ''
    newListItem.querySelector('[data-file-list-target="NameText"]').innerHTML = `${attachment.filename} (${attachment.file_byte_size} MB)`
    newListItem.querySelector('[data-file-list-target="NameText"]').setAttribute('data-attachment-id', attachment.id)
    newListItem.querySelector('[data-file-list-target="NameInput"]').value = attachment.filename
    newListItem.querySelector('[data-file-list-target="NameInput"]').setAttribute('data-attachment-id', attachment.id)
    newListItem.querySelector('[data-file-list-target="EditNameButton"').setAttribute('data-attachment-id', attachment.id)
    newListItem.querySelector('[data-file-list-target="TemplateUploadedTime"]').innerHTML = attachment.uploaded
    newListItem.querySelector('[data-file-list-target="ControlsButton"]').setAttribute('data-attachment-id', attachment.id)
    newListItem.querySelector('[data-file-list-target="ControlsDropdown"]').setAttribute('data-attachment-id', attachment.id)
    const template = document.createElement('template')
    template.innerHTML = attachment.ui_icon
    template.content.firstChild.classList.add("mr-2", "w-6", "h-6")
    newListItem.querySelector('[data-file-list-target="TemplateFiletypeSvg"]').replaceWith(template.content.firstChild)
    const viewLink = newListItem.querySelector('[data-file-list-target="ViewFileLink"]')
    this.updateViewLink(viewLink, attachment)
    this.applyConversionState(newListItem, attachment)
    this.applyVideoState(newListItem, attachment)
    newListItem.setAttribute('data-reorder-url', attachment.reorder_path)
    newListItem.querySelector('[data-file-list-target="NameInput"]').setAttribute('data-url', attachment.rename_path)
    newListItem.querySelector('[data-file-list-target="DeleteFileLink"]').setAttribute('href', attachment.delete_path)
    newListItem.classList.remove("hidden")

    this.element.classList.remove("hidden")
    this.element.append(newListItem)

    const count = $("#item-attachments-count").html()
    $("#item-attachments-count").html(parseInt(count) + 1)
  }

  async checkConversionStatus(attachment_id) {
    const request = new FetchRequest("GET", `/admin/attachments/${attachment_id}`, { responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      const responseJson = await response.json
      this.updateListItemFromResponse(responseJson)
    } else {
      if (this.conversionErrorActionValue != "") {
        this.callControllerMethod(this.conversionErrorActionValue)
      }

      if (window.Sentry) {
        Sentry.captureException('Error checking PDF Conversion status: ' + e)
      }

      Object.keys(this.conversionIntervals).map((key) => {
        clearInterval(this.conversionIntervals[key])
        delete this.conversionIntervals[key]
      })
    }
  }

  async checkVideoStatus(attachmentId) {
    const request = new FetchRequest("GET", `/admin/attachments/${attachmentId}`, { responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      const responseJson = await response.json
      this.updateListItemFromResponse(responseJson)
    } else {
      this.stopVideoInterval(attachmentId)
      if (window.Sentry) {
        Sentry.captureException('Error checking video status for attachment: ' + attachmentId)
      }
    }
  }

  updateListItemFromResponse(attachment) {
    const attachmentItem = this.element.querySelector(`.file-list-item[data-attachment-id="${attachment.id}"]`)
    if (!attachmentItem) { return }

    attachmentItem.dataset.videoStatus = attachment.video_status || ''

    const nameText = attachmentItem.querySelector('[data-file-list-target="NameText"]')
    if (nameText) {
      nameText.innerHTML = `${attachment.filename} (${attachment.file_byte_size} MB)`
    }

    const nameInput = attachmentItem.querySelector('[data-file-list-target="NameInput"]')
    if (nameInput) {
      nameInput.value = attachment.filename
    }

    const uploadedTime = attachmentItem.querySelector('[data-file-list-target="TemplateUploadedTime"]')
    if (uploadedTime) {
      uploadedTime.innerHTML = attachment.uploaded
    }

    const viewLink = attachmentItem.querySelector('[data-file-list-target="ViewFileLink"]')
    this.updateViewLink(viewLink, attachment)

    this.applyConversionState(attachmentItem, attachment)
    this.applyVideoState(attachmentItem, attachment)
  }

  applyConversionState(listItem, attachment) {
    const convertingStatus = listItem.querySelector('[data-file-list-target="ConvertingStatus"]')
    if (!convertingStatus) { return }

    if (attachment.conversion_status == "converting") {
      convertingStatus.classList.remove("hidden")
      if (!this.conversionIntervals[attachment.id]) {
        this.conversionIntervals[attachment.id] = setInterval(() => {
          this.checkConversionStatus(attachment.id)
        }, 2000)
      }
    } else {
      convertingStatus.classList.add("hidden")
      if (this.conversionIntervals[attachment.id]) {
        clearInterval(this.conversionIntervals[attachment.id])
        delete this.conversionIntervals[attachment.id]
      }
    }
  }

  applyVideoState(listItem, attachment) {
    const videoContainer = listItem.querySelector('[data-file-list-target="VideoStatusContainer"]')
    const videoText = listItem.querySelector('[data-file-list-target="VideoStatusText"]')

    if (!videoContainer) { return }

    const status = attachment.video_status
    if (status && status !== 'ready') {
      videoContainer.classList.remove("hidden")
      if (videoText) {
        videoText.textContent = `Video ${this.humanizeVideoStatus(status)}`
      }
      this.startVideoInterval(attachment.id)
    } else {
      videoContainer.classList.add("hidden")
      if (videoText) {
        videoText.textContent = ''
      }
      this.stopVideoInterval(attachment.id)
    }
  }

  initializeExistingVideoPolling() {
    this.ListItemTargets.forEach((item) => {
      const attachmentId = item.dataset.attachmentId
      const videoStatus = item.dataset.videoStatus
      if (videoStatus && videoStatus !== 'ready') {
        this.startVideoInterval(attachmentId)
      }
    })
  }

  startVideoInterval(attachmentId) {
    if (!attachmentId) { return }
    if (this.videoIntervals[attachmentId]) { return }

    this.videoIntervals[attachmentId] = setInterval(() => {
      this.checkVideoStatus(attachmentId)
    }, 4000)
  }

  stopVideoInterval(attachmentId) {
    if (this.videoIntervals[attachmentId]) {
      clearInterval(this.videoIntervals[attachmentId])
      delete this.videoIntervals[attachmentId]
    }
  }

  humanizeVideoStatus(status) {
    if (!status) { return '' }
    return status.replace(/_/g, ' ')
  }

  updateViewLink(linkElement, attachment) {
    if (!linkElement) { return }

    const hasVideoLink = attachment.mux_playback_url && attachment.mux_playback_url.length > 0
    const hasDownloadUrl = attachment.url && attachment.url.length > 0
    const videoStatus = attachment.video_status

    const resetLink = () => {
      linkElement.classList.remove('cursor-not-allowed', 'text-gray-400')
      linkElement.classList.add('hover:bg-gray-200')
    }

    const disableLink = () => {
      linkElement.classList.add('cursor-not-allowed', 'text-gray-400')
      linkElement.classList.remove('hover:bg-gray-200')
    }

    if (hasVideoLink) {
      const targetUrl = attachment.embedded_url || attachment.mux_playback_url
      linkElement.classList.remove('hidden')
      resetLink()
      linkElement.setAttribute('href', targetUrl)
      linkElement.setAttribute('target', '_blank')
      linkElement.textContent = 'View Video'
    } else if (hasDownloadUrl) {
      linkElement.classList.remove('hidden')
      resetLink()
      linkElement.setAttribute('href', attachment.url)
      linkElement.setAttribute('target', '_blank')
      linkElement.textContent = 'View File'
    } else if (videoStatus) {
      linkElement.classList.remove('hidden')
      linkElement.removeAttribute('href')
      linkElement.removeAttribute('target')
      linkElement.textContent = `Video ${videoStatus}`
      disableLink()
    } else {
      linkElement.classList.add('hidden')
      linkElement.removeAttribute('href')
      linkElement.removeAttribute('target')
    }
  }


}
